import { render } from "./VdbFooter.vue?vue&type=template&id=e1801802&scoped=true"
import script from "./VdbFooter.vue?vue&type=script&lang=js"
export * from "./VdbFooter.vue?vue&type=script&lang=js"

import "./VdbFooter.vue?vue&type=style&index=0&id=e1801802&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1801802"]])

export default __exports__